import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
    apiKey: "AIzaSyAbmqiBysYahcdWZG6SJBOa94dt_5VYa2I",
    authDomain: "matiarir-d17a7.firebaseapp.com",
    projectId: "matiarir-d17a7",
    storageBucket: "matiarir-d17a7.appspot.com",
    messagingSenderId: "440913799566",
    appId: "1:440913799566:web:985758df676d8d9a8edcdf",
    measurementId: "G-8WB5Z9NF4L",
};

const VAPID_KEY =
    "BLvv_TxMVwzj6zMhe_6SB68asR-lkAlBIknAobffssgmy8xC0lD6AJNu4zFFBCFiZiepN0MHMLGopSrk-qyn29k";

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

// پیام در حالت foreground
onMessage(messaging, (payload) => {
    console.log("Message received (foreground):", payload);
});

/**
 * این تابع را فقط روی کلیک کاربر صدا بزن
 */
export async function enablePushAndGetToken() {
    try {
        // 1) Permission فقط با gesture
        const permission = await Notification.requestPermission();
        if (permission !== "granted") {
            console.log("Notification permission not granted:", permission);
            return null;
        }

        // 2) Service Worker register + ready
        // مطمئن شو فایل sw در ریشه و درست build می‌شود
        const registration = await navigator.serviceWorker.register("/service-worker.js");
        await navigator.serviceWorker.ready;

        // 3) گرفتن توکن با registration
        const token = await getToken(messaging, {
            vapidKey: VAPID_KEY,
            serviceWorkerRegistration: registration,
        });

        if (!token) {
            console.log("No FCM token returned.");
            return null;
        }

        console.log("FCM token:", token);
        return token;
    } catch (err) {
        console.error("Push init failed safely:", err);
        return null; // مهم: throw نکن که اپ سفید نشه
    }
}